export default __webpack_public_path__ + "static/char-s-12-jp-b6676f2b07df8a3e5ff2eb07dcf37f70.webp";